export default __webpack_public_path__ + "static/media/logo-fridaaXapimo.9ec7c092.svg";